import { Button, Collapse, Stack } from "@mui/material";
import { FormEvent, useCallback, useMemo } from "react";
import { TransitionGroup } from "react-transition-group";
import { usePrescribe } from "src/context/PrescribeProvider/usePrescribe";
import { useStepper } from "src/context/StepperProvider/useStepper";
import MedicationInput from "./components/MedicationInput";
import StepsFooter from "../StepsFooter";
import { usePrescription } from "src/context/PrescriptionProvider";

const SelectMedicationsStep = () => {
  const { handleNext } = useStepper();
  const { selectedMedications, setSelectedMedications, medication } =
    usePrescribe();
  const productCategory = usePrescription((p) => p.product_category.name);
  const isGlp1 = usePrescription((p) => p.product.is_glp1);

  const handleAddMedication = useCallback(() => {
    setSelectedMedications((selected) => selected.concat(selected[0]));
  }, [setSelectedMedications]);

  const handleSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      handleNext();
    },
    [handleNext],
  );

  const disabledAddMedications = useMemo(() => {
    if (medication == null) return true;
    if (medication.form === "injectable") {
      return selectedMedications.length >= 2;
    }

    return true;
  }, [medication, selectedMedications.length]);

  const disableSelectMedications = useCallback(
    (index: number) => {
      if (productCategory === "Weight Loss" && isGlp1) {
        return true;
      }

      return index > 1;
    },
    [isGlp1, productCategory],
  );

  return (
    <Stack component="form" onSubmit={handleSubmit} flexGrow={1}>
      <Stack gap={1}>
        <Button
          variant="text"
          sx={{ alignSelf: "end" }}
          onClick={handleAddMedication}
          disabled={disabledAddMedications}
        >
          + Add Medication
        </Button>
        <TransitionGroup component={null}>
          {selectedMedications.map((medId, index) => (
            <Collapse key={index} timeout={200}>
              <MedicationInput
                disabled={disableSelectMedications(index)}
                index={index}
                canCancel={selectedMedications.length > 1}
                selectedMedicationId={medId}
              />
            </Collapse>
          ))}
        </TransitionGroup>
      </Stack>
      <StepsFooter isFirst />
    </Stack>
  );
};

export default SelectMedicationsStep;
